<template>
  <v-row
    class="ma-0"
    no-gutters
  >
    <v-col
      class="ma-0"
      cols="12"
    >
      <social-media-mentions-block
        :title="$t('Dashboard.Banking.LiquidityRisk.SocialMediaMentions.Title')"
        :is-dashboard="true"
      />
    </v-col>
  </v-row>
</template>

      <script>
import SocialMediaMentionsBlock from '@/theme/default/views/banking/risk/liquidity/risk-monitoring/real-time-monitoring/SocialMediaMentions.vue'

export default {
  name      : 'RealTimeMonitoring',
  components: {
    SocialMediaMentionsBlock
  },
  props: {},
  data () {
    return {}
  }
}
  </script>

  <style scoped>
  </style>
